import { useTranslation } from 'react-i18next';

import { IonCol, IonRow, useIonLoading } from '@ionic/react';

import { useCapturePostHog } from '../../hooks/useCapturePostHog';
import type { AdvocateReportedChatAs } from '../../pages/advocate/AdvocateChatSlice';
import { saveAdvocateReportedChatBy, setOpenReportModal } from '../../pages/advocate/AdvocateChatSlice';
import { useAppDispatch, useAppSelector } from '../../store';
import { TSButton } from '../atomic/TSButton/TSButton';
import { TSModal } from '../atomic/TSModal/TSModal';

export const ReportChatModal = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const [presentLoading, dismissLoading] = useIonLoading();
  const openReportModal = useAppSelector((state) => state.advocateChatSlice.openReportModal);
  const advocateChatUserConn = useAppSelector((state) => state.advocateChatSlice.advocateChatUserConn);

  const close = () => {
    capturePostHogCustomEvent('ReportChatModal dismissed report chat modal', {
      thread_id: advocateChatUserConn?.threadId,
    });
    dispatch(setOpenReportModal(false));
  };

  const report = async (reportedAs: AdvocateReportedChatAs) => {
    if (advocateChatUserConn?.threadId) {
      presentLoading();
      await dispatch(
        saveAdvocateReportedChatBy({
          thread_id: advocateChatUserConn.threadId,
          reported_by_advocate: reportedAs,
        }),
      );
      capturePostHogCustomEvent('ReportChatModal advocate reported chat', {
        reason: reportedAs,
        thread_id: advocateChatUserConn.threadId,
      });
      dismissLoading();
    }
    close();
  };

  return (
    <TSModal
      className="report-chat-modal"
      isOpen={openReportModal}
      onDidDismiss={close}
      mainContent={
        <>
          <IonRow className="ion-padding-top">
            <IonCol className="ion-padding-top headline-small text-bold">
              {t('advocateReportChat.titleReportChat')}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>{t('advocateReportChat.bodyReportChat1')}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol>{t('advocateReportChat.bodyReportChat2')}</IonCol>
          </IonRow>
          <IonRow className="ion-padding-top ion-justify-content-center">
            <TSButton id="report-emergency-btn" variant="black" onClick={() => report('Emergency')}>
              {t('advocateReportChat.btnReportEmergency')}
            </TSButton>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <TSButton id="report-abuse-btn" variant="black" onClick={() => report('Abuse')}>
              {t('advocateReportChat.btnReportAbuse')}
            </TSButton>
          </IonRow>
          <IonRow className="ion-padding-bottom ion-justify-content-center">
            <TSButton variant="white" className="ion-margin-bottom" onClick={close}>
              {t('generic.cancel')}
            </TSButton>
          </IonRow>
        </>
      }
    />
  );
};
